export enum AsyncRequestState {
  Requesting = 'requesting',
  Fulfilled = 'fulfilled',
  Failed = 'failed',
}
